/** Ubah teks tampilan Verifikasi → Validasi tanpa mengubah nilai status/API. */
export function labelValidasi(value) {
  if (value == null || value === '') return value;
  return String(value)
    .replace(/Sudah Diverifikasi/g, 'Sudah Divalidasi')
    .replace(/Belum Diverifikasi/g, 'Belum Divalidasi')
    .replace(/Menunggu Verifikasi/g, 'Menunggu Validasi')
    .replace(/Diverifikasi/g, 'Divalidasi')
    .replace(/diverifikasi/g, 'divalidasi')
    .replace(/Verifikasi/g, 'Validasi')
    .replace(/verifikasi/g, 'validasi');
}
